import React from "react";
import PropTypes from "prop-types";

import { AlertBannerConnector } from "../AlertBannerConnector";
import { CardConnector } from "../CardConnector";
import { CollectionConnector } from "../CollectionConnector";
import { ComponentBlockConnector } from "../ComponentBlockConnector";
import { GalleryConnector } from "../GalleryConnector";
import { HardCodedComponentConnector } from "../HardCodedComponentConnector";
import { IconConnector } from "../IconConnector";
import { LinkButtonConnector } from "../LinkButtonConnector";
import { ListLinkConnector } from "../ListLinkConnector";
import { MultiImageBlockConnector } from "../MultiImageBlockConnector";
import { ParagraphConnector } from "../ParagraphConnector";
import { PromotionRuleConnector } from "../PromotionRuleConnector";
import { ResponsiveBannerConnector } from "../ResponsiveBannerConnector";
import { SectionConnector } from "../SectionConnector";
import { SplitContentWrapperConnector } from "../SplitContentWrapperConnector";
import { TabsAndAccordionConnector } from "../TabsAndAccordionConnector";
import { TimedContentConnector } from "../TimedContentConnector";
import { TopTileConnector } from "../TopTileConnector";
import { VideoPlayerConnector } from "../VideoPlayerConnector";

const FluidSections = ({ data, useWrapper }) =>
	data
		?.filter(x => x)
		?.map(section => {
			const id = section?.sys?.contentType?.sys?.id;
			return (
				<SectionConnector
					key={section.id}
					data={(id === "section" && section) || {}}
					useWrapper={
						(useWrapper || (!useWrapper && id === "section")) &&
						id !== "whiteSpaceComponent" &&
						id !== "componentBlock" &&
						id !== "responsiveBanner" &&
						!(id === "hardCodedComponent" && !section?.markup)
					}>
					{(() => {
						switch (id) {
							case "alertBanner":
								return <AlertBannerConnector data={section} key={section.id} />;
							case "card":
								return <CardConnector data={section} key={section.id} />;
							case "collection":
								return <CollectionConnector data={section} key={section.id} />;
							case "componentBlock":
								return <ComponentBlockConnector data={section} key={section.id} />;
							case "gallery":
								return <GalleryConnector data={section} key={section.id} />;
							case "hardCodedComponent":
								return <HardCodedComponentConnector data={section} key={section.id} />;
							case "icon":
								return <IconConnector data={section} key={section.id} />;
							case "link":
								return <LinkButtonConnector data={section} key={section.id} />;
							case "listLink":
								return <ListLinkConnector data={section} key={section.id} />;
							case "multiImageBlock":
								return <MultiImageBlockConnector data={section} key={section.id} />;
							case "paragraph":
								return <ParagraphConnector data={section} key={section.id} />;
							case "promotionRule":
								return <PromotionRuleConnector data={section} key={section.id} />;
							case "responsiveBanner":
								return <ResponsiveBannerConnector data={section} key={section.id} />;
							case "section":
								return (
									<FluidSections data={section.components} useWrapper={false} key={section.id} />
								);
							case "splitContentWrapper":
								return <SplitContentWrapperConnector data={section} key={section.id} />;
							case "tabsAndAccordion":
								return <TabsAndAccordionConnector data={section} key={section.id} />;
							case "timedComponent":
								return <TimedContentConnector data={section} key={section.id} />;
							case "topTile":
								return <TopTileConnector data={section} key={section.id} />;
							case "videoPlayer":
								return <VideoPlayerConnector data={section} key={section.id} />;
							default:
								return <></>;
						}
					})()}
				</SectionConnector>
			);
		});

FluidSections.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			sys: PropTypes.shape({
				contentType: PropTypes.shape({
					sys: PropTypes.shape({
						id: PropTypes.string.isRequired,
					}).isRequired,
				}).isRequired,
			}).isRequired,
		}).isRequired
	).isRequired,
	useWrapper: PropTypes.bool,
};

FluidSections.defaultProps = {
	useWrapper: true,
};

export { FluidSections };
